import { Box, Typography, useTheme } from "@mui/material";
import FormattedCurrency from "components/WhenBenefit/FormattedCurrency";

interface BenefitSummaryTableProps {
  total: number;
  pending: number;
  reimbursed: number;
  remaining: number;
}
  /* eslint-disable react/prop-types */
const BenefitSummaryTable: React.FC<BenefitSummaryTableProps> = ({ total, pending, reimbursed, remaining }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        background: "#F8F9FA",
        borderRadius: 3,
        p: { xs: 2, sm: 4 },
        mt: 4,
        mb: 4,
        maxWidth: 400,
        mx: "auto",
        boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="body1">Total:</Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          <FormattedCurrency value={total} />
        </Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="body1">Pending:</Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          <FormattedCurrency value={pending} />
        </Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="body1">Reimbursed:</Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          <FormattedCurrency value={reimbursed} />
        </Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="body1">Remaining:</Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold", color: theme.palette.success.main }}>
          <FormattedCurrency value={remaining} />
        </Typography>
      </Box>
    </Box>
  );
};

export default BenefitSummaryTable; 